<ng-container>

    <app-form-generator
        [formId]="formId"
        [formData]="formData"
        [emitFormDataTrigger]="getFormData"
        (emitFormData)="formDataEmitted($event)"
        (emitFormStatus)="formStatusUpdated($event)"
        (emitFormPristine)="formPristineEmitted($event)"
    ></app-form-generator>

    <div class="integration-form-footer">
        <button mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="getFormData = !getFormData" [disabled]="!formValid">{{ 'Save' | translate: {Default: "Save"} }}</button>
    </div>

</ng-container>
